import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { body3SemiBold } from "shared/styles/typography";

import ButtonDefault from "../ButtonDefault";
import { TOOLTIP_PLACEMENT, TooltipGeneral } from "../Tooltips";
import { ContainerProps } from "./types";

const Container = ({
    children,
    id,
    titleLeft,
    titleRight,
    titleColor,
    titleRightColor,
    tooltipContent,
    customValueStyles,
    onHoverOn,
    onHoverOff,
    onValueClick
}: ContainerProps) => {
    const { gray700 } = colors;

    const handleHoverOn = () => id !== undefined && onHoverOn?.(id);
    const handleHoverOff = () => id !== undefined && onHoverOff?.(id);

    return (
        <div>
            <div
                css={css({
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "4px",
                    transition: "color 0.3s ease"
                })}
            >
                <span
                    css={[
                        body3SemiBold,
                        {
                            color: titleColor ?? gray700,
                            wordBreak: "break-word"
                        }
                    ]}
                >
                    {titleLeft}
                </span>

                <TooltipGeneral
                    title={tooltipContent}
                    placement={TOOLTIP_PLACEMENT.Top}
                >
                    <ButtonDefault
                        onMouseEnter={handleHoverOn}
                        onMouseLeave={handleHoverOff}
                        onTouchStart={handleHoverOn}
                        onTouchEnd={handleHoverOff}
                        onClick={onValueClick}
                        css={[
                            body3SemiBold,
                            {
                                color: titleRightColor ?? gray700,
                                marginLeft: "16px",
                                cursor: tooltipContent ? "pointer" : "default",
                                ...customValueStyles
                            }
                        ]}
                    >
                        {titleRight}
                    </ButtonDefault>
                </TooltipGeneral>
            </div>

            <div
                css={css({
                    display: "flex",
                    columnGap: "4px"
                })}
            >
                {children}
            </div>
        </div>
    );
};

export default Container;
